import { useProfileDrawer } from "@/react/components/Drawers/ProfileDrawer";
import type { Notification } from "@/react/types/Notification";

import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const ContactNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isMarkedAsRead: boolean;
}) => {
  const drawer = useProfileDrawer();
  const memberPublicId = notification.action_web_path.split("/").pop() || "";

  return (
    <button
      type="button"
      onClick={event => {
        void drawer.show({
          memberPublicId,
        });
        onClickHandler(event);
      }}
      className="w-full text-left"
    >
      <DefaultNotificationContent
        notification={notification}
        isMarkedAsRead={isMarkedAsRead}
      />
    </button>
  );
};
